export const EnfoqueWebOptions = [
  { icon: "🔘", label: "Todos", value: "", color: "text-black" },
  { icon: "⚫", label: "No definido", value: "No definido", color: "text-gray-500" },
  { icon: "🟢", label: "Ads", value: "Ads", color: "text-green-500" },
  { icon: "🔵", label: "Normal", value: "Normal", color: "text-blue-500" },
]

export const EnfoqueWebColors = {
  "No definido": "text-gray-500",
  "Ads": "text-green-500",
  "Normal": "text-blue-500",
} 